:host {
  @apply block;
  @apply m-auto;
  @apply max-w-1100;
  @apply min-w-253;
}
